import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";

export const TimelineContainer = styled(Box)`
  padding: 0.5rem 1rem 0.5rem 1rem;
  border-radius: 0.5rem;
  background: ${(p) => p.theme.colors.background};
  border: 1px solid ${(p) => p.theme.colors.border2};
`;

export const TimelineRow = styled(Box)`
  display: flex;
`;

export const TimelineSeparatorColumn = styled(Box)`
  width: 1rem;
  min-height: 2rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TimelineConnector = styled(Box)<{ $visible: boolean }>`
  width: 2px;
  background-color: ${(p) =>
    p.$visible ? p.theme.colors.border3 : "transparent"};
`;

export const TimelinePreConnector = styled(TimelineConnector)`
  flex: 0 0 0.5rem;
`;

export const TimelinePostConnector = styled(TimelineConnector)`
  flex: 1;
  min-height: 0.5rem;
`;

export const TimelineDotSlot = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
`;

export const TimelineItemContent = styled(Box)`
  flex: 1;
  padding-right: 0.25rem;
  min-width: 0;
  overflow: hidden;
`;

export const TimelineDoneContent = styled(Box)`
  display: flex;
  align-items: center;
  min-height: 2rem;
`;

export const TimelineDoneText = styled(Typography)`
  font-weight: 700;
  color: ${(p) => p.theme.text.colors.brand};
`;

export const TimelineActionLabel = styled(Typography)`
  font-weight: 700;
  color: ${(p) => p.theme.text.colors.brand};
  display: flex;
  align-items: center;
  min-height: 2rem;
`;
